<script lang="ts" setup>
/* Stores */
import { useCityStore } from '@/store/city/city'

/* Types */
import { AsyncDataKey } from '@/types/main'

const { data: simpleCategories } = useNuxtData(AsyncDataKey.SIMLE_CATEGORIES)

const { cityInfo, phones } = useCityStore()

// Наблюдатель за скроллом для добавления класса к header
const isScroll = ref(false)
const scrollObserverTarget = ref<HTMLElement | null>(null)

// Наблюдатель за позицией блока с категориями, для показа навигации категорий
const isVisibleCategoryMenu = ref(false)

const observeCategoryMenu = () => {
  const mainCategoriesElement = document.querySelector('#desktop-category')

  // Если нет DOM элемента категорий или нет данных из API, выходим
  if (!mainCategoriesElement || !simpleCategories.value.length) return

  useIntersectionObserver(
    mainCategoriesElement,
    {
      threshold: [0, 1],
      rootMargin: '-150px 0px 0px',
    },
    ([entry]) => {
      isVisibleCategoryMenu.value =
        !entry.isIntersecting && entry.boundingClientRect.top !== 0
    },
  )
}

const observeScroll = () => {
  if (!scrollObserverTarget.value) return

  useIntersectionObserver(
    scrollObserverTarget.value,
    { threshold: [0, 0.5, 1] },
    ([{ isIntersecting }]) => {
      isScroll.value = !isIntersecting
    },
  )
}

watch(
  () => simpleCategories.value,
  () => observeCategoryMenu(),
)

onMounted(() => {
  // Не работает через nextTick, поэтому сделал задержку
  setTimeout(() => {
    observeScroll()
    observeCategoryMenu()
  }, 300)
})
</script>

<template>
  <div ref="scrollObserverTarget" class="header-observable-target" />

  <header class="header" :class="{ 'header--scroll': isScroll }">
    <div class="header__container">
      <header-info
        :is-active="cityInfo.is_active"
        :city-name="cityInfo.visible_name"
        :phones="phones"
      />

      <header-widgets :is-active="cityInfo.is_active" />
    </div>

    <header-bottom-menu :is-visible-categories="isVisibleCategoryMenu" />
  </header>
</template>

<style lang="scss" scoped>
.header-observable-target {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  height: 50px;
  pointer-events: none;
  visibility: hidden;
  opacity: 0;
}

.header {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 9;
  max-height: 136px;
  background: var(--ui-white);
  transition: filter 0.3s ease-in;

  &--scroll {
    filter: drop-shadow(0 6px 30px rgba(50, 52, 72, 0.1));
  }

  &__container {
    display: flex;
    justify-content: space-between;
    padding: 26px 24px;

    @include media('height<=desktop-mini-height', '>=desktop-mini') {
      padding: 15px 24px;
    }

    @include media('>=desktop') {
      max-width: 1200px;
      padding: 26px 0;
      margin: 0 auto;
    }
  }
}
</style>
